module.exports = __webpack_public_path__ + "media/app_search/Billing/assets/logo-ec--small-efad0095f615c39a021f0bf0f46b065e.svg";